//colors
export const WALL_COLOR = "#FCCC88";
export const WEIGHT_COLOR = "deepskyblue";
export const WEIGHT_DONE = "purple";
export const WEIGHT_PATH = "#74B652";
export const START_COLOR = "lightgreen";
export const END_COLOR = "#FF4136";
export const PATH_COLOR = "#01FF70";
export const DEFAULT_COLOR = "white";
export const CELL_BORDER = "lightgrey";
//icons
export const WALL_IMG = "wallIcon.svg";
export const WEIGHT_IMG = "weight.svg";
export const START_IMG = "startIcon.svg";
export const END_IMG = "endIcon.svg";
export const PATH_IMG = "pathIcon.svg";
export const LOGO_IMG = "logo2.svg";
export const TRUE_IMG = "algoTrue.svg";
export const FALSE_IMG = "cancel.svg";

//animations
export const FIRST_ANIMATION_COLOR = "#ff9b85";
export const SECOND_ANIMATION_COLOR = "#e1b382";
export const THIRD_ANIMATION_COLOR = "#ffa990";
export const FOURTH_ANIMATION_COLOR = "#ffd97d";
